import styled from 'styled-components'

import Card from '~/components/Card'

export const Container = styled(Card)`
	grid-area: pagamento;
	display: grid;
	grid-template-columns: auto 24px;
	grid-template-rows: 30px auto;
	grid-template-areas:
		'title edit_icon'
		'pagamento pagamento';

	> h1 {
		font-size: 19px;
		font-weight: 500;
	}

	> div {
		grid-area: pagamento;
		margin-top: 24px;
		display: flex;
		flex-wrap: wrap;
		align-self: flex-start;
		line-height: 24px;

		span {
			margin-right: 28px;
		}
	}

	> svg {
		color: #FFF;
		transition: 300ms;

		&:hover {
			opacity: 0.7;
			cursor: pointer;
		}
	}

	.spinner-container {
		grid-area: pagamento;
		justify-self: center;
	}

	.razao-bloqueio {
		display: flex;
		align-items: center;
		background-color: #ffeb3bDD;
		color: #424242;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 10px;
		margin-top: 20px;
		font-weight: 500;

		svg {
			margin-right: 10px;
		}
	}

	@media(max-width: 440px) {
		margin: 0;
		border-radius: 0;
	}
`
